if (!customElements.get("lsg-footer")) customElements.define("lsg-footer", class LSGFooter extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            navbarToogle: ".js-lsg-footer-nav-toggle"
        };

        this.navbarToogle = this.querySelectorAll(this.selectors.navbarToogle);
        this.init();
    }

    init() {
        this.navbarToogle.forEach(el=>{
            el.addEventListener('click',()=>{
                el.setAttribute("aria-expanded", !(el.getAttribute("aria-expanded")=='true'));
                const otherToggles = [...this.navbarToogle].filter(toggle => {return toggle != el});
                otherToggles.forEach(otherToggle => {
                    otherToggle.setAttribute('aria-expanded', false);
                });
            })
        });

    }
});
